// extracted by mini-css-extract-plugin
export default {"nav":"ProfileNavbar_nav__jTfU3"};